import React, { useState, useEffect } from "react";
import { isMobile } from "../../Utils/media-query";
import Popup, { ToolbarItem } from "devextreme-react/popup";
import useFetch from "../../Hooks/useFetch";
import { useNavigate } from "react-router-dom";
import ErrorMessage from "../../Components/ErrorMessage";
import {
  DataGrid,
  Column,
  RequiredRule,
  Editing,
  SearchPanel,
  Item,
  Toolbar,
  HeaderFilter,
  Lookup,
} from "devextreme-react/data-grid";
import ActionNotifications from "../../Components/ActionNotifications";
import useGetSupplierList from "../../Hooks/useGET/useGetSupplierList";
import handleDelSupplierList from "../../Utils/handleDEL/handleDelSupplierList";
import handlePutSupplierList from "../../Utils/handlePUT/handlePutSupplierList";
import handlePostSupplierList from "../../Utils/handlePOST/handlePostSupplierList";
import useGetAllTimeOffs from "../../Hooks/useGET/useGetAllTimeOffs";
import { renderStatusConst } from "./Components/renderStatusConst";
import "./styles.css";
import { DateBox, Button as DxButton } from "devextreme-react";
import useGetTimeOffsByDateRange from "../../Hooks/useGET/useGetTimeOffsByDateRange";

const statuses = [
  { id: 0, text: "In Review" },
  { id: 1, text: "Approved" },
  { id: 2, text: "Denied" },
];

export default function TimeOff() {
  const navigate = useNavigate(),
    fetch = useFetch(navigate),
    [notifyResponse, setResponse] = useState({}),
    [startDate, setStartDate] = useState(null),
    [endDate, setEndDate] = useState(null),
    [filteredTimeOffs, setFilteredTimeOffs] = useState([]);
  const { timeOffs, mutate, error } = useGetAllTimeOffs();
  const { timeOffsByDateRange, mutate: mutateDateRange } =
    useGetTimeOffsByDateRange(startDate, endDate);

  //update every 12hours
  useEffect(() => {
    const interval = setInterval(
      () => {
        mutate();
      },
      12 * 60 * 60 * 1000,
    );
    return () => clearInterval(interval);
  }, [mutate, mutateDateRange, startDate, endDate]);

  useEffect(() => {
    if (startDate && endDate) {
      setFilteredTimeOffs(timeOffsByDateRange || []);
    } else {
      setFilteredTimeOffs(timeOffs || []);
    }
  }, [startDate, endDate, timeOffsByDateRange, timeOffs]);
  const fetchSuccessful = (response) => {
    setResponse(response);
    return (
      response?.success &&
      response?.data?.statusCode &&
      response?.success !== "Invalid Model"
    );
  };
  const renderGrid = () => {
    return (
      <DataGrid
        dataSource={filteredTimeOffs || []}
        fullScreen={isMobile}
        height="80vh"
        showBorders={true}
      >
        <Toolbar>
          <Item
            location="before"
            locateInMenu="never"
            render={() => (
              <div>
                <h1 className="white">Time Offs</h1>
              </div>
            )}
          />
          <Item
            location="after"
            render={() => (
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: 10,
                  flexWrap: "wrap",
                }}
              >
                <DateBox
                  width={200}
                  type="date"
                  value={startDate}
                  displayFormat="yyyy-MM-dd"
                  placeholder="Select Start Date"
                  onValueChanged={(e) => setStartDate(e.value)}
                />
                <DateBox
                  width={200}
                  type="date"
                  value={endDate}
                  displayFormat="yyyy-MM-dd"
                  placeholder="Select End Date"
                  onValueChanged={(e) => setEndDate(e.value)}
                />
                {/* <DxButton
                  text="Get Details"
                  type="default"
                  stylingMode="outlined"
                  // onClick={handleGetDetailsByDateRange}
                />
                <DxButton
                  text="Reset"
                  type="normal"
                  stylingMode="outlined"
                  onClick={handleResetFilter}
                /> */}
              </div>
            )}
          ></Item>
          <Item name="searchPanel" />
        </Toolbar>
        <SearchPanel
          visible={true}
          searchVisibleColumnsOnly={true}
          placeholder="Search..."
        />
        <HeaderFilter visible={true} />
        <Column
          visible={false}
          dataField="id"
          alignment="left"
          allowEditing={false}
          allowHeaderFiltering={false}
        />
        <Column dataField="user" allowHeaderFiltering={false} />
        <Column
          dataField="workCenter"
          visible={true}
          allowHeaderFiltering={true}
        />
        <Column
          dataField="ptoDates.startDate"
          dataType="datetime"
          caption="Start Date"
          visible={true}
          allowHeaderFiltering={false}
        />
        <Column
          dataField="ptoDates.endDate"
          dataType="datetime"
          caption="End Date"
          visible={true}
          allowHeaderFiltering={false}
        />
        <Column
          dataField="status"
          cellRender={(e) => renderStatusConst(e.data.status)}
          allowHeaderFiltering={true}
        >
          <Lookup dataSource={statuses} valueExpr="id" displayExpr="text" />
        </Column>
      </DataGrid>
    );
  };

  return (
    <div className="px-lg-4 content">
      <ActionNotifications response={notifyResponse} />
      <div className="flexBoxRowSCC">
        <div className="px-2 page-content">
          <div className="contentBox my-3">
            {!error ? renderGrid() : <ErrorMessage />}
          </div>
        </div>
      </div>
    </div>
  );
}
